var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.49999C17 3.36738 16.9473 3.24021 16.8536 3.14644C16.7598 3.05267 16.6326 2.99999 16.5 2.99999H14C12.7411 2.93728 11.5086 3.37538 10.5717 4.21857C9.63485 5.06176 9.06978 6.24149 9 7.49999V10.2H6.5C6.36739 10.2 6.24021 10.2527 6.14645 10.3464C6.05268 10.4402 6 10.5674 6 10.7V13.3C6 13.4326 6.05268 13.5598 6.14645 13.6535C6.24021 13.7473 6.36739 13.8 6.5 13.8H9V20.5C9 20.6326 9.05268 20.7598 9.14645 20.8535C9.24021 20.9473 9.36739 21 9.5 21H12.5C12.6326 21 12.7598 20.9473 12.8536 20.8535C12.9473 20.7598 13 20.6326 13 20.5V13.8H15.62C15.7312 13.8016 15.8397 13.7661 15.9285 13.6991C16.0172 13.6321 16.0811 13.5374 16.11 13.43L16.83 10.83C16.8499 10.7561 16.8526 10.6787 16.8378 10.6036C16.8231 10.5285 16.7913 10.4578 16.7449 10.397C16.6985 10.3361 16.6388 10.2867 16.5704 10.2526C16.5019 10.2184 16.4265 10.2004 16.35 10.2H13V7.49999C13.0249 7.25247 13.1411 7.0231 13.326 6.85669C13.5109 6.69027 13.7512 6.59875 14 6.59999H16.5C16.6326 6.59999 16.7598 6.54731 16.8536 6.45355C16.9473 6.35978 17 6.2326 17 6.09999V3.49999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogoWhite);
export default __webpack_public_path__ + "static/media/facebookLogoWhite.25163ebd16d40f778d67a88e8054147b.svg";
export { ForwardRef as ReactComponent };